import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CashierService } from '@beautyapp/core';
import { map } from 'rxjs/operators';

@Injectable()
export class CashierFacade {
  private cashierService = inject(CashierService);

  cashierOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  refreshCurrentCashier: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  refreshCashier: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  cashierIsOpen$ = this.cashierOpen.asObservable();
  currentCashierRefresh$ = this.refreshCurrentCashier.asObservable();
  cashierRefresh$ = this.refreshCashier.asObservable();

  refreshCurrentCashierList() {
    this.refreshCurrentCashier.next(true);
  }

  refreshCashierList() {
    this.refreshCashier.next(true);
  }

  openCashier(state: boolean) {

    this.cashierOpen.next(state);
  }

  checkCashierIsOpen(): Observable<any> {
    return this.cashierService.getCurrentViewNew().pipe(
      map((res) => {
        console.log(res)
        this.cashierOpen.next(res.status === 'PENDING');
        return res;
      })
    );
  }
}
